import React, { useState } from 'react';
import { Routes, Route, useNavigate, useSearchParams } from 'react-router-dom';
import BookingPage from './pages/BookingPage';
import AdminPage from './pages/AdminPage';
import AdminLoginPage from './pages/AdminLoginPage';
import PaymentSuccessPage from './pages/PaymentSuccessPage';
import { Toaster } from './components/ui/toaster';
import './App.css';

// Admin route wrapper to handle authentication
function AdminRoute() {
  const navigate = useNavigate();
  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    return sessionStorage.getItem('adminToken') === 'authenticated';
  });

  const handleLogin = (success) => {
    if (success) {
      setIsAuthenticated(true);
      sessionStorage.setItem('adminToken', 'authenticated');
    }
  };

  const handleLogout = () => {
    setIsAuthenticated(false);
    sessionStorage.removeItem('adminToken');
    navigate('/');
  };

  if (!isAuthenticated) {
    return <AdminLoginPage onLogin={handleLogin} />;
  }

  return <AdminPage onLogout={handleLogout} />;
}

// Payment success wrapper to handle session_id from query params
function PaymentSuccessRoute() {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session_id');
  
  return <PaymentSuccessPage sessionId={sessionId} />;
}

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<BookingPage />} />
        <Route path="/CruiseAdmin" element={<AdminRoute />} />
        <Route path="/payment-success" element={<PaymentSuccessRoute />} />
      </Routes>
      <Toaster />
    </div>
  );
}

export default App;